<template>
 <div class="new-member">
   <div class="container-fluid">
     <sidebar />
     <div class="col-md-9 col-lg-10 ml-md-auto">
       <div id="scroll" class="header d-flex justify-content-start w-100 align-items-center py-3 mb-5 border-bottom border-dark">
         <h2 class="my-3">新規会員情報追加</h2>
       </div>
      <div v-if="apiStatus">
        {{statusAlert(true)}}
      </div>
      <div v-show="status" class="validation py-3 px-5 my-4">
          <p class="m-0">{{ status }}</p>
      </div>
      <div v-if="invalidEmail" class="validation py-3 px-5 my-4">
          {{this.status = null}}
          <p class="m-0">エラー：すべてのフィールドを確認して、再試行してください</p>
      </div>
       <div class="main-bg py-3 px-2 mb-4 p-3 mb-2 bg-light text-dark">
         <b-container fluid>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">氏名</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.fullname.$model" class="form-input" placeholder="山田太郎" :state="validateState('fullname')"></b-form-input>
                <b-form-invalid-feedback :state="validateState('fullname')">
                    <p v-if="!$v.memberAccount.fullname.required">氏名は必須です</p>
                    <p v-if="!$v.memberAccount.fullname.maxLength">30文字以下で入力してください</p>
                    <p v-if="!$v.memberAccount.fullname.minLength">氏名{{$v.memberAccount.fullname.$params.minLength.min}}文字以上入力してください</p>
                </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">フリガナ</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.fullname_furigana.$model" class="form-input" placeholder="ヤマダタロウ" :state="validateState('fullname_furigana')"></b-form-input>
                <b-form-invalid-feedback :state="validateState('fullname_furigana')">
                    <p v-if="!$v.memberAccount.fullname_furigana.maxLength">30文字以下で入力してください</p>
                    <p v-if="!$v.memberAccount.fullname_furigana.minLength">氏名{{$v.memberAccount.fullname_furigana.$params.minLength.min}}文字以上入力してください</p>
                </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">メールアドレス</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.email_address.$model" :input="emailCheck" class="form-input" placeholder="global@lead-real.co.jp" :state="validateState('email_address')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('email_address')">
                <p v-if="$v.$invalid">{{emailCheck()}}</p>
                <p v-if="!$v.memberAccount.email_address.required">メールアドレスを入力してください</p>
                <p v-if="!$v.memberAccount.email_address.email">メールアドレスを正しく入力してください</p>
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!$v.$invalid" :state="false">
                <p v-if="invalidEmail">このメールアドレスは使用できません。</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">パスワード</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.password.$model" class="form-input" type="text" placeholder="" :state="validateState('password')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('password')">
                <p v-if="!$v.memberAccount.password.required">パスワードは必須です</p>
                <p v-if="!$v.memberAccount.password.minLength">パスワード{{$v.memberAccount.password.$params.minLength.min}}文字以上入力してください</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">国名</label>
            </b-col>
            <b-col lg="4">
              <b-form-select required v-model="$v.memberAccount.country.$model" class="form-select" :state="validateState('country')" @change="changeCountry">
                <b-form-select-option :value="null" disabled>選択してください</b-form-select-option>
                <b-form-select-option  v-for="(country, index) in countries" :key="index" :value="country" :state="validateState('country')">{{country}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('country')">
                <p v-if="!$v.memberAccount.country.required">国名は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">都道府県</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="memberAccount.prefectures" class="form-select" :disabled="memberAccount.country !== 'Japan'">
                <b-form-select-option :value="null" disabled>選択して下さい</b-form-select-option>
                <b-form-select-option  v-for="(prefecture, index) in countriesPrefectures" :key="index" :value="prefecture">{{prefecture}}</b-form-select-option>
              </b-form-select>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">郵便番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.postal_code.$model" class="form-input" placeholder="150-0036" :state="validateState('postal_code')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('postal_code')">
                <p v-if="!$v.memberAccount.postal_code.required">郵便番号は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">住所</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="$v.memberAccount.address.$model" class="form-input" placeholder="東京都渋谷区南出台町16-11 MFPR渋谷南平台ビル6階" :state="validateState('address')"></b-form-input>
              <b-form-invalid-feedback :state="validateState('address')">
                <p v-if="!$v.memberAccount.address.maxLength">80文字以下で入力してください</p>
                <p v-if="!$v.memberAccount.address.required">住所すは必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">電話番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberAccount.phone_number" class="form-input" placeholder="03-5784-5127"></b-form-input>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">FAX番号</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberAccount.fax_number" class="form-input" type="tel" maxlength="12" placeholder="03-5784-5127"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">年齢</label>
            </b-col>
            <b-col lg="4" class="d-flex align-items-center">
              <b-form-select v-model="$v.memberAccount.age.$model" class="form-select" :state="validateState('age')">
                <b-form-select-option :value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="(item, index) in ageSetup" :key="index" :value="item">{{item + $t('exts')}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('age')">
                <p v-if="!$v.memberAccount.age.required">年齢は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">性別</label>
            </b-col>
            <b-col lg="4" class="align-items-center">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberAccount.gender.$model" :state="validateState('gender')">
                  <b-form-radio value="Male">男性</b-form-radio>
                  <b-form-radio value="Female">女性</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-invalid-feedback :state="validateState('gender')">
                <p v-if="!$v.memberAccount.gender.required">性別は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">物件用途</label>
            </b-col>
            <b-col lg="4" class="align-items-center">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberAccount.use_of_the_property.$model" :state="validateState('use_of_the_property')">
                  <b-form-radio v-for="item in propertyUses" :key="item" :value="item">{{$t(item)}}</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-invalid-feedback :state="validateState('use_of_the_property')">
                <p v-if="!$v.memberAccount.use_of_the_property.required">物件用途は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">検討中の物件種別</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberAccount.types_of_properties.$model" class="form-select" :disabled="!memberAccount.use_of_the_property" :state="validateState('types_of_properties')">
                <b-form-select-option :value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="item in propertyTypeList" :key="item" :value="item">{{item}}</b-form-select-option>
              </b-form-select>
              <b-form-invalid-feedback :state="validateState('types_of_properties')">
                <p v-if="!$v.memberAccount.types_of_properties.required">検討中の物件種別は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">希望価格帯</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberAccount.desired_price_range.$model" class="form-select" :state="validateState('desired_price_range')">
                <b-form-select-option :value="null" disabled="disabled" selected>選択してください</b-form-select-option>
                <b-form-select-option v-for="item in priceList" :key="item" :value="item">{{$t(item)}}</b-form-select-option>
            </b-form-select>
              <b-form-invalid-feedback :state="validateState('desired_price_range')">
                <p v-if="!$v.memberAccount.desired_price_range.required">希望価格帯は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">メルマガ配信</label>
            </b-col>
            <b-col lg="4" class="align-items-center">
              <b-form-group class="m-0 form-radio-button">
                <b-form-radio-group v-model="$v.memberAccount.email_magazine_delivery.$model" :state="validateState('email_magazine_delivery')">
                  <b-form-radio value="ok">OK</b-form-radio>
                  <b-form-radio value="ng">NG</b-form-radio>
                </b-form-radio-group>
              </b-form-group>
              <b-form-invalid-feedback :state="validateState('email_magazine_delivery')">
                <p v-if="!$v.memberAccount.email_magazine_delivery.required">メルマガ配信は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">言語</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="$v.memberAccount.language.$model" class="form-select" :state="validateState('language')" :options="languageList"></b-form-select>
              <b-form-invalid-feedback :state="validateState('language')">
                <p v-if="!$v.memberAccount.language.required">言語は必須です</p>
              </b-form-invalid-feedback>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0 required">プラン</label>
            </b-col>
            <b-col lg="4">
              <b-form-radio-group v-model="$v.memberAccount.privileged.$model" :state="validateState('privileged')">
                <b-form-radio value="1">リード社プラン</b-form-radio>
                <b-form-radio value="0">無料</b-form-radio>
              </b-form-radio-group>
              <b-form-invalid-feedback :state="validateState('privileged')">
                <p v-if="!$v.memberAccount.privileged.required">プランは必須です</p>
              </b-form-invalid-feedback>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">会社名</label>
            </b-col>
            <b-col lg="4">
              <b-form-input v-model="memberAccount.company_name" class="form-input" placeholder="株式会社リード・リアルエステート"></b-form-input>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">会社概要</label>
            </b-col>
            <b-col lg="4">
              <b-form-textarea v-model="memberAccount.company_description" class="form-input"></b-form-textarea>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">業種</label>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox id="business_type_indivisual" v-model="memberAccount.business_type_indivisual">
                <label for="business_type_indivisual" class="checkbox">{{ $t('business_type_indivisual') }}</label>
              </b-form-checkbox>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox id="business_type_developer" v-model="memberAccount.business_type_developer">
                <label for="business_type_developer" class="checkbox">{{ $t('business_type_developer') }}</label>
              </b-form-checkbox>
            </b-col>
            <b-col lg="3" class="align-items-center d-flex">
              <b-form-checkbox id="business_type_mediator" v-model="memberAccount.business_type_mediator">
                <label for="business_type_mediator" class="checkbox">{{ $t('business_type_mediator') }}</label>
              </b-form-checkbox>
            </b-col>
          </b-row>

          <b-row class="my-3">
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">エリア</label>
            </b-col>
            <b-col lg="4">
              <b-form-select v-model="memberAccount.area" class="form-select">
                <b-form-select-option :value="null">選択して下さい</b-form-select-option>
                <b-form-select-option  v-for="(area, index) in prefectures" :key="index" :value="area">{{area}}</b-form-select-option>
              </b-form-select>
            </b-col>
            <b-col lg="2" class="align-items-center d-flex">
              <label class="m-0">エリア詳細</label>
            </b-col>
            <b-col lg="4">
              <b-form-textarea v-model="memberAccount.area_detail" class="form-input"></b-form-textarea>
            </b-col>
          </b-row>

        </b-container>
       </div>
       <div class="d-flex justify-content-start align-items-center mb-3">
         <a href="#scroll" class="text-decoration-none text-white" v-smooth-scroll><b-button class="py-2 px-5" variant="primary" @click="addMember()">保存</b-button></a>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import { required, email, minLength, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'
import sidebar from '@/components/_sidebar/sidebar'
import { languages, memberAges, businessPropertyValues, propertyUses, propertyPrices } from '../../assets/data/values'

export default {
  data () {
    return {
      residentialList: businessPropertyValues.propertyTypes.residential,
      investmentList: businessPropertyValues.propertyTypes.investment,
      ageSetup: memberAges,
      priceList: propertyPrices,
      propertyUses: propertyUses,
      languageList: [{ text: '選択してください', disabled: true }].concat(languages.map(l => { return { value: l, text: this.$i18n.t(l) } })),
      selectedCountry: null,
      emailError: true,
      memberAccount: {
        fullname: null,
        fullname_furigana: null,
        email_address: null,
        password: null,
        postal_code: null,
        country: 'Japan',
        prefectures: null,
        address: null,
        phone_number: null,
        fax_number: null,
        age: null,
        gender: null,
        use_of_the_property: null,
        desired_price_range: null,
        types_of_properties: null,
        language: null,
        email_magazine_delivery: null,
        privileged: null,
        company_name: null,
        company_description: null,
        business_type_mediator: false,
        business_type_developer: false,
        business_type_indivisual: false,
        area: null,
        area_detail: null
      },
      status: null,
      loadingState: false,
      error: null
    }
  },
  validations: {
    memberAccount: {
      fullname: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      fullname_furigana: {
        minLength: minLength(2),
        maxLength: maxLength(30)
      },
      email_address: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      },
      country: { required },
      address: {
        required,
        maxLength: maxLength(80)
      },
      age: { required },
      postal_code: { required },
      gender: { required },
      use_of_the_property: { required },
      desired_price_range: { required },
      types_of_properties: { required },
      language: { required },
      email_magazine_delivery: { required },
      privileged: { required }
    }
  },
  created () {
    this.prefectureCountry()
    this.$store.commit('setApiStatus', null)
    this.$store.commit('adminAddMember/setInvalidEmail', null)
  },
  computed: {
    ...mapState(['errors', 'apiStatus']),
    ...mapState('adminAddMember', ['progress', 'countries', 'prefectures', 'invalidEmail']),
    countriesPrefectures () {
      switch (this.selectedCountry) {
        case 'japan':
          return this.prefectures
        case 'other':
          return this.countries
        default:
          return this.prefectures
      }
    },
    propertyTypeList () {
      if (this.memberAccount.use_of_the_property === 'Residential use') {
        return this.residentialList
      }
      return this.investmentList
    }
  },
  methods: {
    ...mapActions('adminAddMember', ['addNewMember', 'prefectureCountry']),
    validateState (name) {
      const { $dirty, $error } = this.$v.memberAccount[name]
      return $dirty ? !$error : null
    },
    addMember: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.status = 'エラー：すべてのフィールドを確認して、再試行してください'
      } else {
        this.$v.$reset()
        this.addNewMember(this.$v.memberAccount.$model)
        if (this.invalidEmail !== null) {
          this.$v.memberAccount.email_address.$reset()
        }
      }
    },
    statusAlert (append = false) {
      this.$bvToast.toast('body', {
        title: this.apiStatus,
        toaster: 'b-toaster-top-center',
        solid: true,
        appendToast: append,
        autoHideDelay: 3000
      })
    },
    emailCheck: function () {
      this.$store.commit('adminAddMember/setInvalidEmail', null)
    },
    changeCountry () {
      if (this.memberAccount.country !== 'Japan') {
        this.memberAccount.prefectures = null
      }
    }
  },
  watch: {
    apiStatus: function () {
      this.memberAccount = {
        fullname: null,
        fullname_furigana: null,
        email_address: null,
        password: null,
        postal_code: null,
        country: 'Japan',
        prefectures: null,
        address: null,
        phone_number: null,
        fax_number: null,
        age: null,
        gender: null,
        use_of_the_property: null,
        desired_price_range: null,
        types_of_properties: null,
        language: null,
        email_magazine_delivery: null,
        privileged: null,
        company_name: null,
        company_description: null,
        business_type_developer: null,
        business_type_mediator: null,
        business_type_indivisual: null,
        area: null,
        area_detail: null
      }
      this.$nextTick(() => {
        this.$v.$reset()
      })
      this.status = null
      this.$store.commit('adminAddMember/setInvalidEmail', null)
    }
  },
  components: {
    sidebar
  }
}
</script>
